import { UserRole } from '@sb-tools/typescript/enums/user-role.enum';
import { CommunityUserExtended } from '@sb-tools/typescript/models/community-user-extended.model';
import { CustomerSettings } from '@sb-tools/typescript/models/customer-settings.model';
import { isInboxElementVisible } from './is-inbox-element-visible.util';

type LeftPanelVisibilityUser = Pick<CommunityUserExtended, 'hasHelperCategories' | 'isReadOnly' | 'role'> | undefined;
type LeftPanelVisibilitySettings = Pick<CustomerSettings, 'inboxElementsVisibility' | 'isBotEnabled'> | undefined;

export function isInboxLeftSidebarVisible(
    user: LeftPanelVisibilityUser,
    customerSettings: LeftPanelVisibilitySettings,
    hasVisibleLeftMenuFilters?: boolean,
): boolean {
    const leftPanel = customerSettings?.inboxElementsVisibility?.leftPanel;

    if (!isInboxElementVisible(leftPanel?.wholeLeftMenu)) {
        return false;
    }

    return (
        isInboxElementVisible(leftPanel?.communitySelector) ||
        (!user?.isReadOnly && isInboxElementVisible(leftPanel?.createTicket)) ||
        (customerSettings?.isBotEnabled === true && isInboxElementVisible(leftPanel?.botTicketsView)) ||
        isInboxElementVisible(leftPanel?.inboxView) ||
        ((user?.role === UserRole.admin || user?.role === UserRole.manager) &&
            isInboxElementVisible(leftPanel?.allTicketsView)) ||
        (user?.hasHelperCategories === true && isInboxElementVisible(leftPanel?.helperTicketsView)) ||
        (!user?.isReadOnly && isInboxElementVisible(leftPanel?.filters) && hasVisibleLeftMenuFilters !== false)
    );
}
